import useViewer from "../viewer-context/useViewer";
import useJigsawEvent from "../viewer-context/useJigsawEvent";
import JigsawEvent from "../viewer-context/JigsawEvent";
import { promisifyJigsawCall } from "../../external/utils";

enum NavEvent {
  PAGE_CHANGE = "page:change",
}

export default function useNavApi() {
  const viewer = useViewer().viewer as jigsaw.Viewer;

  useJigsawEvent(JigsawEvent.PAGE_BREAK, (e, data) => {
    document.dispatchEvent(
      new CustomEvent(NavEvent.PAGE_CHANGE, { detail: { page: data } })
    );
  });

  function goToPage(page: string | number): void {
    viewer.Book.goToPage(page);
  }

  function goToCFI(cfi: string): void {
    viewer.Book.goToCFI(cfi);
  }

  function getPageBreaks() {
    return promisifyJigsawCall(viewer.Book.getPageBreaks.bind(viewer.Book));
  }

  return {
    goToPage,
    goToCFI,
    getPageBreaks,
  };
}
